import { ref, reactive, watchEffect } from 'vue'
import { tryOnScopeDispose } from '@vueuse/core'

/**
 * @typedef {Object} RAFTime
 * @property {number} delta
 * @property {number} timestamp
 */

const listeners = new Map()
let RAFID, lastUpdate, globalDelta

const checkRaf = () => {
  if (listeners.size > 0) {
    !RAFID && (RAFID = window.requestAnimationFrame(rafUpdate))
  } else {
    window.cancelAnimationFrame(RAFID)
    RAFID = null
    lastUpdate = null
  }
}

const rafUpdate = (_timestamp) => {
  const time = Date.now()
  globalDelta = (lastUpdate ? time - lastUpdate : 0) / 1000
  globalDelta = Math.min(Math.max(globalDelta, 0), 0.5)
  lastUpdate = time

  listeners.forEach(({ fn, active, time }, key) => {
    if (active.value) {
      time.deltaTime = globalDelta
      time.timestamp = _timestamp
      typeof fn === 'function' && fn(globalDelta, _timestamp)
    }
  })

  RAFID = null
  checkRaf()
}
/**
 *
 * @param {Function} fn
 * @param {boolean} immediate
 */
export const useRAF = (fn, immediate = false) => {
  const key = typeof fn === 'function' ? fn : () => {}
  const active = ref(immediate)
  const time = reactive({ delta: 0, timestamp: 0 })
  /**
   * @param {boolean} state
   */
  const toggle = state => (active.value = state === undefined ? !active.value : state)
  const dispose = () => toggle(false)

  watchEffect(() => {
    if (active.value) {
      !listeners.get(key) && listeners.set(key, { fn, active, time })
    } else {
      listeners.get(key) && listeners.delete(key)
    }
    checkRaf()
  })

  tryOnScopeDispose(dispose)

  return {
    time,
    active,
    dispose,
    toggle,
    activate: () => toggle(true)
  }
}

export default useRAF
